import { c as _c } from "react/compiler-runtime";
import request from '@onefootprint/request';
import type { SkipLivenessRequest, SkipLivenessResponse } from '@onefootprint/types';
import { AUTH_HEADER } from '@onefootprint/types';
import { useMutation } from '@tanstack/react-query';
const skipLiveness = async (payload: SkipLivenessRequest) => {
  const {
    authToken,
    ...data
  } = payload;
  const response = await request<SkipLivenessResponse>({
    method: 'POST',
    url: '/hosted/onboarding/skip_passkey_register',
    data,
    headers: {
      [AUTH_HEADER]: authToken
    }
  });
  await new Promise(resolve => setTimeout(resolve, 500));
  return response.data;
};
const useSkipLiveness = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: skipLiveness
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
};
export default useSkipLiveness;